import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Skeleton } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import { AuthContext } from "../../../context/auth-context";
import ProductItem from "../../CategoryDiscovery/Products/ProductItem";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import useCustomerReviews from "./../../CategoryDiscovery/CustomerReviews/useCustomerReviews";
import useClassifyProduct from "./../../CategoryDiscovery/Products/useClassifyProduct";
import CompetitorItem from "./CompetitorItem";
import classes from "./Competitors.module.css";
import { LLM_OPTIONS } from "../../../utils/constant";
import { filterKey } from "../BrandAudit";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";
import { OVERVIEW_LLM_LABELS } from "../../../utils/constant";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Tooltip from "@mui/material/Tooltip";
const COMPETITORS_PER_ROW = 3;

export default function Competitors(
  { category, brand, llm, market, isCategoryOverview, ctx, headerControls = null } = {}
) {
  const [error, setError] = useState();
  const [visibleCount, setVisibleCount] = useState(COMPETITORS_PER_ROW);
  const containerRef = useRef(null);
  const { user } = useContext(AuthContext);
  const { license_status } = user?.customer;

  const abortControllersRef = useRef([]);
  const _defaultCtx = useContext(DiscoveryContext);
  const discoveryCtx = ctx || _defaultCtx;
  const { classifiedProducts } = useClassifyProduct();
  const selectedMarket = discoveryCtx.state.selectedMarket;
  const selectedPersona = discoveryCtx.state.selectedPersona;
  const selectedLLM = discoveryCtx?.state?.selectedLLM;
  const { loading: reviewsLoading, reviews } = useCustomerReviews();

  let competitors = discoveryCtx.competitors[category].map((c) => c.name);

  useEffect(() => {
    setVisibleCount(COMPETITORS_PER_ROW);
  }, [competitors.length]);

  const totalCompetitors = competitors.length;
  const isExpanded = visibleCount >= totalCompetitors;

  const toggleShowMore = () => {
    if (visibleCount < totalCompetitors) {
      setVisibleCount(totalCompetitors);
    } else {
      setVisibleCount(COMPETITORS_PER_ROW);
    }
  };

  let brandScoreTotal = discoveryCtx.brand_scores[llm]?.[category]?.[1]?.total;
  useEffect(() => {
    if (brandScoreTotal > 0 || discoveryCtx.state.id) return;
    // getBrandIndexScores();

    return () => {
      //abortControllersRef.current.forEach((controller) => controller.abort());
    };
  }, [brandScoreTotal, competitors.length, discoveryCtx.state.id]);

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      abortControllersRef.current.forEach((controller) => controller.abort());
    }
  }, [discoveryCtx.abort_launch]);

  let brandData = discoveryCtx.brand_scores[llm]?.[category]?.[selectedMarket]?.[selectedPersona];
  const scroll = (direction) => {
    if (containerRef.current) {
      const scrollAmount = 480;
      const newScrollPosition =
        direction === "next"
          ? containerRef.current.scrollLeft + scrollAmount
          : containerRef.current.scrollLeft - scrollAmount;
      containerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };

  let id = `competitor`;

  let uniqueKey = `${tab[category]}_${id}_${selectedLLM ?? ""}_${selectedMarket ?? ""}_${selectedPersona ?? ""}`;

  const { checked } = useIsSelectedSection({ id, uniqueKey });

  const visibleCompetitors =
    discoveryCtx.type === "category"
      ? competitors
      : competitors.slice(0, visibleCount);

  return (
    <MUICard>
      <div className="Heading-checkbox">
        <h5>
          {discoveryCtx.type === "category" ? (
            "Products"
          ) : (
            <span className={classes.headingWithToggle}>
              Competitor Analysis
              {totalCompetitors > 3 && (
                <Tooltip
                  title={
                    isExpanded
                      ? "Collapse competitors"
                      : "Expand to view more competitors"
                  }
                  placement="top"
                  arrow
                >
                  <span className={classes.toggleIconWrapper}>
                    {isExpanded ? (
                      <KeyboardArrowUpIcon
                        onClick={toggleShowMore}
                        fontSize="small"
                      />
                    ) : (
                      <KeyboardArrowDownIcon
                        onClick={toggleShowMore}
                        fontSize="small"
                      />
                    )}
                  </span>
                </Tooltip>
              )}
            </span>
          )}
        </h5>

        {discoveryCtx.state.showReportCheckbox && isCategoryOverview && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title:
                    discoveryCtx.type === "category"
                      ? "Products"
                      : "Competitor Analysis",
                  tab: tab[category],
                  uniqueKey,
                  category: category,
                  market: selectedMarket,
                  llm
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}

        <div
          style={{ flex: 1, display: "flex", gap: 8, justifyContent: "flex-end", alignItems: "center" }}
          className={classes.dropdownWrapper}
          id="llm_options"
        >
          {headerControls}
          <MUISelect
            fullWidth={false}
            optionValue={selectedLLM}
            label={"LLM"}
            id={filterKey.llm}
            options={(discoveryCtx.llm || []).map((llm) => {
              const match= OVERVIEW_LLM_LABELS[llm]
              return {
                name: match ? match : llm,
                value: llm,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedLLM(e.target.value);
            }}
          />
        </div>
      </div>

      {discoveryCtx.type === "category" && (
        <>
          <MUIIconButton
            className={`${classes.chevron_btn} ${classes.prev}`}
            onClick={() => scroll("prev")}
          >
            <ArrowBackIosNewIcon />
          </MUIIconButton>
          <MUIIconButton
            className={`${classes.chevron_btn} ${classes.next}`}
            onClick={() => scroll("next")}
          >
            <ArrowForwardIosIcon />
          </MUIIconButton>
        </>
      )}
      <div
        ref={containerRef}
        id={id}
        style={{ position: "relative" }}
        className={
          discoveryCtx.type === "category"
            ? classes.products_container
            : classes.container
        }
      >
        {visibleCompetitors?.map((competitor, index) => {
          return (
            <React.Fragment key={index}>
              {discoveryCtx.type === "category" ? (
                <ProductItem
                  classifiedProducts={classifiedProducts}
                  index={index}
                  name={competitor}
                  brandIndex={
                    brandData[
                      index + (discoveryCtx.type === "category" ? 0 : 1)
                    ]
                  }
                  reviews={reviews[index]}
                  reviewLoading={reviewsLoading}
                />
              ) : (
                <div id={`competitoritem-${index + 1}`}>
                  <CompetitorItem
                    competitor={competitor}
                    brandIndex={brandData[index + 1]}
                    brand={brand}
                    llm={llm}
                    category={category}
                    market={selectedMarket}
                    persona={selectedPersona}
                    ctx={ctx}
                  />
                </div>
                // ) : (
                //   <Skeleton
                //     variant="rounded"
                //     style={{
                //       flexGrow: 1,
                //       height: 220,
                //       flexBasis: "calc(50% - 12.5px)",
                //     }}
                //   />
                // )}
              )}
            </React.Fragment>
          );
        })}
      </div>
    </MUICard>
  );
}
